import React from 'react';

import styled from 'styled-components';

import { ContractProvider } from 'common/Contract/ContractContext';

import ShopDataModalContent from './ShopDataModalContent';
import ShopDataModalSidebar from './sidebar/ShopDataModalSidebar';

const Container = styled.div`
  display flex;
  grow: 1;
  margin-right: 30px;
  border-right: 1px solid var(--line-gray);
  border-top: 1px solid var(--line-gray);
  width: 100%;
`;

const ShopDataModalLayout = () => {
  return (
    <ContractProvider>
      <Container>
        <ShopDataModalSidebar />
        <ShopDataModalContent />
      </Container>
    </ContractProvider>
  );
};

export default ShopDataModalLayout;
